import { useFormikContext } from 'formik';
import React from 'react';
import { InputLabel, Spacer } from 'src/common';
import {
  BillingTypeSelect,
  BusinessTypeSelect,
  EnvironmentTypeSelect,
  OrganisationTypeSelect,
  PlanTypeSelect,
  ServiceModelSelect,
} from 'src/components/select';
import { SettingsOptions, UpsertOrganisationMutationVariables } from 'src/graphql/_generated';
import styled from 'styled-components';

const Div = styled.div``;

interface Step2Props {
  selectedSettingsOption?: SettingsOptions;
}

export const Step2: React.FC<Step2Props> = ({ selectedSettingsOption }) => {
  const { values, errors, touched, setFieldValue, setFieldTouched } =
    useFormikContext<UpsertOrganisationMutationVariables>();

  return (
    <Div>
      <InputLabel>ORGANISATION TYPE</InputLabel>
      <OrganisationTypeSelect
        onChange={(o) => {
          setFieldValue('organisationType', o.value);

          setFieldValue('businessType', null);
          setFieldValue('planType', null);
          setFieldValue('billingType', null);
          setFieldValue('serviceModel', null);
          setFieldValue('environmentType', null);
        }}
        onBlur={() => setFieldTouched('organisationType', true)}
        value={values.organisationType}
        css="width: 100%;"
        error={touched.organisationType && Boolean(errors.organisationType)}
      />
      <Spacer $px={20} />

      <InputLabel>SERVICE MODEL</InputLabel>
      <ServiceModelSelect
        filteredOptions={selectedSettingsOption?.serviceModel?.map((o) => o!)}
        onChange={(o) => setFieldValue('serviceModel', o.value)}
        onBlur={() => setFieldTouched('serviceModel', true)}
        value={values.serviceModel}
        css="width: 100%;"
        error={touched.serviceModel && Boolean(errors.serviceModel)}
      />
      <Spacer $px={20} />

      <InputLabel>BUSINESS TYPE</InputLabel>
      <BusinessTypeSelect
        filteredOptions={selectedSettingsOption?.businessType?.map((o) => o!)}
        onChange={(o) => setFieldValue('businessType', o.value)}
        onBlur={() => setFieldTouched('businessType', true)}
        value={values.businessType}
        css="width: 100%;"
        error={touched.businessType && Boolean(errors.businessType)}
      />
      <Spacer $px={20} />

      <InputLabel>BILLING TYPE</InputLabel>
      <BillingTypeSelect
        filteredOptions={selectedSettingsOption?.billingType?.map((o) => o!)}
        onChange={(o) => setFieldValue('billingType', o.value)}
        onBlur={() => setFieldTouched('billingType', true)}
        value={values.billingType}
        css="width: 100%;"
        error={touched.billingType && Boolean(errors.billingType)}
      />
      <Spacer $px={20} />

      <InputLabel>PRICING PLAN</InputLabel>
      <PlanTypeSelect
        filteredOptions={selectedSettingsOption?.planType?.map((o) => o!)}
        onChange={(o) => setFieldValue('planType', o.value)}
        onBlur={() => setFieldTouched('planType', true)}
        value={values.planType}
        css="width: 100%;"
        error={touched.planType && Boolean(errors.planType)}
      />
      <Spacer $px={20} />

      <InputLabel>ENVIRONMENT TYPE</InputLabel>
      <EnvironmentTypeSelect
        filteredOptions={selectedSettingsOption?.environmentType?.map((o) => o!)}
        onChange={(o) => setFieldValue('environmentType', o.value)}
        onBlur={() => setFieldTouched('environmentType', true)}
        value={values.environmentType}
        css="width: 100%;"
        error={touched.environmentType && Boolean(errors.environmentType)}
      />
    </Div>
  );
};
